import React from 'react';
import Api from '../Api';
import * as actions from '../redux/actions';
import Util from '../Util';
import $ from 'jquery';

class HostDetailHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'Unknown',
      statusMsg: '',
      lastFetchedStatusStr: Util.xUnitsOfTimeAgo(props.hostInfo.lastFetched),
    };

    let hostInfo = props.hostInfo;
    if (hostInfo && (hostInfo.kioskName || hostInfo.ip)) {
      this.checkAlive(props.hostInfo);
    }
  }

  componentWillUpdate(nextProps) {
    if (this.props.hostInfo.id !== nextProps.hostInfo.id && nextProps.hostInfo.kioskName) {
      setTimeout(() => {
        this.checkAlive(nextProps.hostInfo);
      }, 500);
      this.setState({
        lastFetchedStatusStr: Util.xUnitsOfTimeAgo(nextProps.hostInfo.lastFetched),
      });
    }
  }

  componentDidMount() {
    this.lastFetchedTimer = setInterval(
      () =>
        this.setState({
          lastFetchedStatusStr: Util.xUnitsOfTimeAgo(this.props.hostInfo.lastFetched),
        }), 5000);
  }

  componentWillUnmount() {
    clearTimeout(this.lastFetchedTimer);
    this.unmounted = true;
  }

  checkAlive(hostInfo) {
    setTimeout(() => {
      let $statusIcon = $('#status-icon');
      $statusIcon.addClass('fa-refresh fa-spin');

      Api.checkAlive(hostInfo)
        .then((result) => {
          if (this.unmounted) return;
          this.setState({
            status: 'Online',
            statusMsg: result.status,
          });
          $statusIcon.removeClass('fa-refresh fa-spin');
          $statusIcon.addClass('animated tada');
        })
        .catch((e, result) => {
          if (this.unmounted) return;
          result = result || {};
          this.setState({
            status: 'Unreachable',
            statusMsg: result.status,
          });
          $statusIcon.removeClass('fa-refresh fa-spin');
          $statusIcon.addClass('animated tada');
        });
    }, 800); // delay some time since component may not mounted fully?
  }

  handleRefresh() {
    const { dispatch, hostInfo } = this.props;
    this.checkAlive(hostInfo);

    let $refreshIcon = $('#refresh-icon');
    $refreshIcon.addClass('fa-spin');
    $refreshIcon.removeClass('animated tada');

    dispatch(actions.fetchInfo(hostInfo))
      .then(() => {
        $refreshIcon.removeClass('fa-spin');
        $refreshIcon.addClass('animated tada');
      })
      .catch((e) => {
        $refreshIcon.removeClass('fa-spin');
        $refreshIcon.addClass('animated tada');
        alert('Refresh failed: ' + e.message); // todo: use alert component
      });
  }

  render() {
    let { hostInfo, bodyView, onBodyViewChange, goBack } = this.props;
    let { status, statusMsg, lastFetchedStatusStr } = this.state;
    let isBadFetchStatus = hostInfo.isBadFetchStatus;

    let linuxdashUrl = `http://${hostInfo.ip}:5555`;
    let statusContainer;

    switch (status) {
      case 'Online':
        statusContainer = (
          <div className='title-status' title='Online'>
            <i className='fa fa-power-off' title={statusMsg} />
          </div>
        );
        break;
      case 'Unreachable':
        statusContainer = (
          <div className='title-status' title='Unreachable' style={{ color: '#f07686' }}>
            <i
              id='status-icon'
              className='fa fa-power-off'
              style={{ color: '#f07686' }}
              title={statusMsg}
            />{' '}
            Unreachable
          </div>
        );
        break;
      default:
        statusContainer = (
          <div className='title-status' title='Unknown'>
            <i
              id='status-icon'
              style={{ color: 'lightgrey' }}
              className='fa fa-power-off'
              title={statusMsg}
            />
          </div>
        );
        break;
    }

    let kskText;
    if (hostInfo.kioskName) {
      kskText = `ksk: ${hostInfo.kioskName} | loc: ${hostInfo.locationName} | org: ${hostInfo.orgName}`;
    }

    let kioskImgPath = null;
    if (hostInfo.isRTKiosk) {
      if (/CS/.test(hostInfo.sfecfgServices)) {
        kioskImgPath = '/img/RT-CS-200.jpg';
      } else {
        kioskImgPath = '/img/RT-SS-200.jpg';
      }
    } else if (hostInfo.isV5Kiosk) {
      kioskImgPath = '/img/V5-MM-200.png';
    }

    return (
      <div className='title-row'>
        <div className='title-back' onClick={goBack}>
          <i className='fa fa-chevron-left' />
        </div>

        <div className='title'>
          <div className='title-info'>
            {kioskImgPath && (
              <img
                className=''
                src={kioskImgPath}
                style={{
                  display: 'inline',
                  verticalAlign: 'middle',
                  height: 30,
                  margin: 10,
                  marginRight: 0,
                }}
              />
            )}
            {statusContainer}
            {hostInfo.kioskName ? (
              <span title={kskText} style={{ marginLeft: '10px' }}>
                <span style={{ fontSize: 12, opacity: 0.6 }}>ksk:</span>{' '}
                <span style={{ marginRight: '10px' }}>{hostInfo.kioskName} </span>
                <span style={{ fontSize: 12, opacity: 0.6 }}>loc:</span>{' '}
                <span style={{ marginRight: '10px' }}>{hostInfo.locationName} </span>
                <span style={{ fontSize: 12, opacity: 0.6 }}>org:</span>{' '}
                <span style={{ marginRight: '10px' }}>{hostInfo.orgName} </span>|{' '}
                <span style={{ fontSize: 12, opacity: 0.6 }}>ipaddr:</span>{' '}
                <span style={{ marginRight: '10px' }}>{hostInfo.ip} </span>|{' '}
                <span style={{ fontSize: 12, opacity: 0.6 }}>type:</span>{' '}
                <span style={{ marginRight: '10px' }}>{hostInfo.kioskType}</span>
                <span style={{ fontSize: 11, opacity: 1 }}>
                  {hostInfo.kskUseVpnIPAddr && '(Using IP Address)'}
                </span>
              </span>
            ) : (
              <span style={{ marginLeft: '10px' }}>
                <span style={{ fontSize: 12, opacity: 0.6 }}>ipaddr:</span>{' '}
                <span style={{ marginRight: '10px' }}>{hostInfo.ip} </span>
                <span style={{ fontSize: 12, opacity: 0.6 }}>hostname:</span>{' '}
                <span style={{ marginRight: '10px' }}>{hostInfo.hostname} </span>
                <span style={{ fontSize: 12, opacity: 0.6 }}>type:</span>{' '}
                <span style={{ marginRight: '10px' }}>{hostInfo.hostType} </span>
              </span>
            )}
          </div>
        </div>
        <div style={{ position: 'absolute', top: 7, right: 60, color: 'white' }}>
          <a
            style={{ display: 'block', textAlign: 'right', color: 'white' }}
            href={linuxdashUrl}
            target='linuxdashUrl'
          >
            linuxdash {hostInfo.linuxdashVer}
          </a>
          <span style={{ color: isBadFetchStatus ? '#f07686' : '' }}>
            Last DashBeat {lastFetchedStatusStr}
          </span>
        </div>
        <div
          className='refresh-container'
          style={{ position: 'absolute', top: 10, right: 15 }}
          title='Refresh'
        >
          <i id='refresh-icon' className='fa fa-refresh' onClick={this.handleRefresh.bind(this)} />
        </div>
        <div className='detail-link-header' style={{ textAlign: 'right', padding: '5px' }}>
          <a
            className={bodyView === 'overview' ? 'detail-link__selected' : ''}
            onClick={onBodyViewChange.bind(this, 'overview')}
            href='javascript:void(0)'
          >
            <i className='fa fa-wpforms' /> Overview
          </a>
          <a
            className={bodyView === 'json' ? 'detail-link__selected' : ''}
            onClick={onBodyViewChange.bind(this, 'json')}
            href='javascript:void(0)'
          >
            <i className='fa fa-list' /> JSON Data
          </a>
          {hostInfo.hasSosdbKiosk && (
            <a
              className={bodyView === 'update-history' ? 'detail-link__selected' : ''}
              onClick={onBodyViewChange.bind(this, 'update-history')}
              href='javascript:void(0)'
            >
              <i className='fa fa-list-alt' /> Update History
            </a>
          )}
          {hostInfo.hasKioskInfo && (
            <a
              className={bodyView === 'sheldon' ? 'detail-link__selected' : ''}
              onClick={onBodyViewChange.bind(this, 'sheldon')}
              href='javascript:void(0)'
            >
              <i className='fa fa-user-secret' /> Sheldon
            </a>
          )}
        </div>
      </div>
    );
  }
}

export default HostDetailHeader;



// WEBPACK FOOTER //
// ./src/components/HostDetailHeader.js